/* Turtle Oracle v41 · reading finder + motion toggle.
   Voice: Rachael Nike's intake assistant. Short, curious, one question at a time. */
(function () {
  'use strict';

  /* ---- pause / play the walking scene ---- */
  document.querySelectorAll('[data-t41-motion]').forEach(function (btn) {
    var scene = btn.parentNode.querySelector('[data-t41-walk]');
    if (!scene) return;
    btn.addEventListener('click', function () {
      var paused = scene.classList.toggle('t41-paused');
      btn.textContent = paused ? 'Play' : 'Pause';
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    });
  });

  /* ---- reading finder ---- */
  var log = document.querySelector('[data-t41-log]');
  var box = document.querySelector('[data-t41-choices]');
  var dataEl = document.querySelector('[data-t41-readings]');
  if (!log || !box || !dataEl) return;

  var R = {};
  try { R = JSON.parse(dataEl.textContent); } catch (e) { R = {}; }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }

  function bot(text) {
    var t = el('div', 't41-typing'); t.innerHTML = '<i></i><i></i><i></i>';
    log.appendChild(t);
    return wait(Math.min(1100, 380 + text.length * 9)).then(function () {
      t.remove(); log.appendChild(el('div', 't41-msg t41-msg--bot', text));
    });
  }
  function me(text) { log.appendChild(el('div', 't41-msg t41-msg--me', text)); }

  function ask(options) {
    box.innerHTML = '';
    options.filter(function (o) { return !o.needs || o.needs.every(function (k) { return R[k]; }); })
      .forEach(function (o) {
        var b = el('button', '', o.label); b.type = 'button';
        b.addEventListener('click', function () { box.innerHTML = ''; me(o.label); o.go(); });
        box.appendChild(b);
      });
  }

  function recommend(key, why) {
    var r = R[key];
    if (!r) { return bot('I can’t find that reading right now. Every reading is in the shop.').then(function () { showAll(); }); }
    return bot(why).then(function () {
      var card = el('div', 't41-frame t41-rec');
      card.innerHTML =
        '<svg viewBox="0 0 64 64" aria-hidden="true"><use href="#' + r.el + '"/></svg>' +
        '<div><h3></h3><div class="t41-rec__meta"></div><p></p>' +
        '<div class="t41-rec__row"><a class="t41-btn" href="' + r.url + '">Start this reading →</a>' +
        '<button class="t41-restart" type="button">Start over</button></div></div>';
      card.querySelector('h3').textContent = r.name;
      card.querySelector('.t41-rec__meta').textContent = r.price + ' · PDF in 24–48 hours';
      card.querySelector('p').textContent = r.copy;
      card.querySelector('.t41-restart').addEventListener('click', start);
      log.appendChild(card);
    });
  }
  function showAll() {
    var a = el('a', 't41-btn', 'See every reading →'); a.href = '/collections/readings'; log.appendChild(a);
  }

  function start() {
    log.innerHTML = ''; box.innerHTML = '';
    bot('Hi. I’m here to help you find the right reading.')
      .then(function () { return bot('What are you trying to understand?'); })
      .then(function () {
        ask([
          { label: 'This full moon', needs: ['moon'], go: function () { recommend('moon', 'The Hunter’s Moon Reading. Where this full moon in Taurus lands in one chart, yours or your animal’s. Open through Monday.'); } },
          { label: 'My animal', needs: ['pet'], go: function () {
            bot('Okay. Is this just about them, or about the two of you together?').then(function () {
              ask([
                { label: 'Just them', needs: ['pet'], go: function () { recommend('pet', 'Then start with their Pet Birth Chart. It’s built from their actual natal chart, not their breed.'); } },
                { label: 'The two of us', needs: ['bond'], go: function () { recommend('bond', 'That’s a Kindred Bond. Your chart and theirs, read together.'); } }
              ]);
            });
          } },
          { label: 'Someone new came home', needs: ['fall'], go: function () {
            bot('Congratulations. Do you want to know who they are, or read the day they came home?').then(function () {
              ask([
                { label: 'Who they are', needs: ['fall'], go: function () { recommend('fall', 'Their First Fall With You. Temperament, comfort, trust, and what helps them settle in.'); } },
                { label: 'The day they came home', needs: ['gotcha'], go: function () { recommend('gotcha', 'A Gotcha Day Reading. The sky of the day they became yours.'); } },
                { label: 'Both', needs: ['pair'], go: function () { recommend('pair', 'Then the First Fall + Gotcha Day Collection. Both readings from one intake.'); } }
              ]);
            });
          } },
          { label: 'Myself', needs: ['personal'], go: function () {
            bot('Do you have one thing on your mind, or do you want the whole picture?').then(function () {
              ask([
                { label: 'The whole picture', needs: ['personal'], go: function () { recommend('personal', 'Then your Personal Birth Chart. The whole chart, read as one system.'); } },
                { label: 'Just one thing', needs: ['ask'], go: function () { recommend('ask', 'Ask the Stars. One question, read through your chart.'); } }
              ]);
            });
          } },
          { label: 'An animal I’ve lost', needs: ['lasting'], go: function () {
            bot('I’m sorry. Take your time with this.').then(function () { return wait(300); })
              .then(function () { recommend('lasting', 'The Lasting Bond is for this. It looks at them and what the two of you were. The first one was Turtle’s.'); });
          } },
          { label: 'Something small to keep', needs: ['mark'], go: function () { recommend('mark', 'A Celestial Mark. A small visual piece made from one real chart.'); } },
          { label: 'I’m not sure yet', go: function () {
            bot('That’s fine. Who’s on your mind right now?').then(function () {
              ask([
                { label: 'An animal', needs: ['pet'], go: function () { recommend('pet', 'Start with their Pet Birth Chart. You can always add the bond later.'); } },
                { label: 'Me', needs: ['personal'], go: function () { recommend('personal', 'Start with your Personal Birth Chart.'); } },
                { label: 'Both of us', needs: ['bond'], go: function () { recommend('bond', 'Then it’s a Kindred Bond.'); } }
              ]);
            });
          } }
        ]);
      });
  }

  var started = false;
  function go() { if (!started) { started = true; start(); } }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { go(); io.disconnect(); } }, { threshold: 0.25 });
    io.observe(log);
  } else { go(); }
})();
